module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjkiIGhlaWdodD0iMjkiIHZpZXdCb3g9IjAgMCAyOSAyOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMyIgeT0iMTAiIHdpZHRoPSIyMyIgaGVpZ2h0PSI5IiByeD0iMSIgc3Ryb2tlPSIjMUE4NUU0IiBzdHJva2Utd2lkdGg9IjIiLz4KPHJlY3QgeD0iNiIgeT0iMTMuNSIgd2lkdGg9IjciIGhlaWdodD0iMiIgcng9IjEiIGZpbGw9IiMxQTg1RTQiLz4KPHJlY3QgeD0iMTQiIHk9IjEzLjUiIHdpZHRoPSI1IiBoZWlnaHQ9IjIiIHJ4PSIxIiBmaWxsPSIjMUE4NUU0Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-form-ui/field-icon-active/multiple_selection.svg
// module id = QWNF
// module chunks = 46